<template>
  <div class="container search">
    <page-head
      :title="title"
    />

    <products-list
      v-if="PRODUCTS.length"
    />
    <page-info
      v-else
      title="Товары не найдены"
      class="page-info offset-page-info"
    >
      Попробуйте ввести другой
      <a @click.prevent="$f.toggleSearch">
        поисковый запрос
      </a>
      или посмотрите каталог по разделам
    </page-info>

    <product-gallery-slot
      v-if="!PRODUCTS.length"
      :with-category="false"
      slot-name="popular_main"
      class="offset-recommendation-gallery"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import { commonGtmEvents } from '@/gtm/common-gtm-events';
import productsList from '../components/catalog/products-list.vue';
import PageHead from '../components/common/page-head.vue';
import PageInfo from '../components/common/page-info.vue';
import ProductGallerySlot from '@/components/product-gallery-slot/product-gallery-slot.vue';

export default {
  name: 'search',
  components: {
    productsList,
    PageHead,
    PageInfo,
    ProductGallerySlot,
  },

  computed: {
    ...mapGetters({
      PRODUCTS: 'category/products',
      SEARCH_RESULT_PRODUCTS: 'category/products',
      PRODUCTS_COUNT: 'category/productsCount',
    }),

    query() {
      return this.$route.query?.query || '';
    },

    foundProductsText() {
      return `
        ${this.$options.filters.decl(this.PRODUCTS_COUNT, 'найден', ['', 'о', 'о'])}
        ${this.PRODUCTS_COUNT}
        ${this.$options.filters.decl(this.PRODUCTS_COUNT, 'товар', ['', 'а', 'ов'])}
      `;
    },

    title() {
      if (this.PRODUCTS_COUNT && this.query) {
        return `По запросу «${this.query}» ${this.foundProductsText}`;
      } else if (!this.query) {
        return 'Поисковый запрос не введен';
      }
      return `По запросу «${this.query}» товары не найдены`
    },
  },

  mounted() {
    // Google Tag Manager event
    commonGtmEvents.viewSearchPage({ query: this.query });
  },

  methods: {
    ...mapActions({
      LOAD_PAGE_DATA: 'category/loadData',
    }),
  },

  serverPrefetch () {
    return this.LOAD_PAGE_DATA();
  },
};
</script>

<style lang="scss">
  @import "@/components/common/page-info-with-gallery.scss";
</style>
